export enum Workflow {
  Internal = 'internal',
  External = 'external',
  FollowUp = 'follow-up',
}

export const reviewTypeMap: { [key: string]: string } = {
  internal: 'review-request',
  external: 'external-review-request',
  'follow-up': 'follow-up',
};
